import React from 'react'

export default function OEIButton(props) {
    return (
        <button type="button" className="default-button default-button--fat default-button--confirm-safe"onClick={props.onclick}>
        <span>{props.labelName}</span>
      </button>
    )
}
